import React from 'react';
import Panel from './Panel';
import AdminPageHolder from '../AdminPanelsPage/AdminPageHolder';

const api = '/api/flip-and-win';

export default () => (
    <AdminPageHolder
        title="AdminPageFlipAndWin"
        schema={{
            '@context': 'http://schema.org',
            '@type': 'AdminPageFlipAndWin',
            description: 'Admin panel',
            name: 'Admin panel',
        }}
    >
        <Panel api={api} />
    </AdminPageHolder>
);
